<template lang="pug">
	.downdraft-breadcrumb
		p.downdraft-breadcrumb__static {{ labels.breadcrumb }}:
		.downdraft-breadcrumb__content
			span.downdraft-breadcrumb__step(v-for="(item, index) in completedSteps")
				strong {{ item[0] }}
				p {{ item[1] }}
				i.arrow_carrot-right(v-if="index !== completedSteps.length - 1")
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: ['labels', 'session', 'config'],
  computed: {
    completedSteps() {
      let arr = []
      this.config.forEach((el, index) => {
        if (!!this.session[el.title] && index + 1 !== this.config[this.config.length - 1].step) {
          let obj = el.options.find((opt) => {
            return opt.id === this.session[el.title]
          })
          arr.push([`${el.title}:`, obj.name])
        }
      })
      return arr
    },
  },
  methods: {},
  mounted() {},
}
</script>

<style lang="scss" scoped>
.downdraft-breadcrumb {
  display: flex;
  flex-direction: column;
  padding-bottom: 2rem;
  p,
  strong {
    height: 1.5rem;
    line-height: 1.5rem;
    margin-bottom: 0;
    padding-right: 0.15rem;
    display: inline-block;
  }
  &__content {
    min-height: 1.5rem;
    display: flex;
    flex-wrap: wrap;
  }
  &__static {
    margin-right: 0.5rem;
  }
  &__step {
    padding-right: 0.5rem;
    overflow: hidden;
    display: flex;
    i {
      height: 1.5rem;
      font-size: 1.3rem;
    }
  }
}
</style>
